<div class="map__tooltip-box" #mapTooltipContainer>
  @if (isOpen && inUseTemplate) {
    <ng-container
      *ngTemplateOutlet="
        inUseTemplate;
        context: { feature: feature, close: boundCloseButton }
      "
    ></ng-container>
  }
</div>
